import React, {useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {logPageLoadEvents} from '@ibibo/analytics';
import {
  fetchMyTripsDetailsData,

  myTripDetailsParamsSelector,
  myTripDetailsHeaderDataSelector,
  myTripDetailsBookingDataSelector,
  myTripBookingDetailsSelector,
  myTripHotelDetailsSelector,
  myTripDetailsActionLinkSelector,
  myTripPaymentDetailsSelector,
  myTripBookingInfoSelector,
  myTripDetailsImportantInfoSelector,
  myTripDetailsPoliciesSelector
} from '@ibibo/myaccount-reducer';

import * as S from './myTripsDetails.styles';

import DetailsHeader from '../../../stories/components/myTripDetails/DetailsHeader/DetailsHeader';
import DetailsBody from '../../../stories/components/myTripDetails/DetailsBody/DetailsBody';
import MyTripDetailsLoader from '../../../stories/components/myTripDetails/LoaderBlock/Loader';

const MyTripsDetails = () => {

  const dispatch = useDispatch();

  const detailsParams = useSelector(myTripDetailsParamsSelector);
  const tripDetails = useSelector(myTripDetailsBookingDataSelector);
  const headerDetails = useSelector(myTripDetailsHeaderDataSelector);
  const bookingDetails = useSelector(myTripBookingDetailsSelector);
  const paymentDetails = useSelector(myTripPaymentDetailsSelector);
  const hotelDetails = useSelector(myTripHotelDetailsSelector);
  const bookingInfo = useSelector(myTripBookingInfoSelector);
  const actionLinks = useSelector(myTripDetailsActionLinkSelector);
  const impInfo = useSelector(myTripDetailsImportantInfoSelector);
  const policiesInfo = useSelector(myTripDetailsPoliciesSelector);

  const {trip_type} = tripDetails || '';

  const fetchMyTripsDetailsDataCaller = useCallback(() => {
    return dispatch(fetchMyTripsDetailsData(detailsParams));
  }, [dispatch]);

  useEffect(() => {
    fetchMyTripsDetailsDataCaller();
  }, []);

  useEffect(() => {
    if(tripDetails && tripDetails.hotel_country){
      let searchType = 'domestic';
      if(tripDetails.hotel_country !== "India"){
        searchType = 'intl';
      }
      logPageLoadEvents(`postbooking:${searchType} hotels mybookings:bookingdetail`, {});
    }
  }, [tripDetails]);

  if (!tripDetails) {
    return <S.DetailsMainWrapper>
      <MyTripDetailsLoader />
    </S.DetailsMainWrapper>;
  }

  return(
    <S.DetailsMainWrapper>
      <DetailsHeader headerDetails={headerDetails} />
      <DetailsBody
        bookingDetails={bookingDetails}
        hotelDetails={hotelDetails}
        actionLinks={actionLinks}
        paymentDetails={paymentDetails}
        bookingInfo={bookingInfo}
        trip_type={trip_type}
        impInfo={impInfo}
        policiesInfo={policiesInfo}
      />
    </S.DetailsMainWrapper>
  );
}

export default MyTripsDetails;